"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "montefranco": {
    "26468045": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "ampognano": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "15498829": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "castellonalto": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a9400b94": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "castellone-basso": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c27f70d3": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "colle-olivo": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e4f847c6": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "colli": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "463ea588": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "le-mura": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "35c91cf0": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "leazzano": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d5068e22": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "lorino": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "1db14995": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "macchialunga": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b16a4c38": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "macelleto": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "957cfd8d": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "macenano": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "87987a06": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "monterivoso": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "05072fee": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "nicciano": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "4a22c8b5": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "sambucheto": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "6280d5bc": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "san-mamiliano": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b8ae81be": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "skipSearch": false
    }],
    "terria": [{
      "hkey": "3c5442e9",
      "slug": "montefranco",
      "name": "Montefranco",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;